const __WEBPACK_NAMESPACE_OBJECT__ = require("@lunit/design-system-icons");